import { render, staticRenderFns } from "./exportAndImport.vue?vue&type=template&id=5b256ddf&scoped=true&"
import script from "./exportAndImport.vue?vue&type=script&lang=js&"
export * from "./exportAndImport.vue?vue&type=script&lang=js&"
import style0 from "./exportAndImport.vue?vue&type=style&index=0&id=5b256ddf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b256ddf",
  null
  
)

export default component.exports